export const ALL_CARDS = [
  {
    key: "events",
    label: "EVENTS",
    group: "Events",
    className: "events",
    iconClass: "icon-calendar",
    cardName: "Events",
  },
  {
    key: "eventsAdd",
    label: "ADD EVENTS",
    group: "Events",
    className: "eventsAdd",
    iconClass: "icon-calendar-add",
    cardName: "Add Events",
  },
  {
    key: "eventDetails",
    label: "EVENT DETIALS",
    group: "Events",
    className: "eventDetails",
    iconClass: "icon-calendar-info",
    cardName: "Event Details",
  },
  {
    key: "users",
    label: "USERS",
    group: "Users",
    className: "user-management",
    iconClass: "icon-user",
    cardName: "User Management",
  },
  {
    key: "userAdd",
    label: "UPDATE USERS",
    group: "Users",
    className: "user-management",
    iconClass: "icon-new-user",
    cardName: "Update Users",
  },
  {
    key: "usersCredit",
    label: "USERS CREDIT",
    group: "Users",
    className: "users-credit",
    iconClass: "icon-users-credit",
    cardName: "Users Credit",
  },
  {
    key: "bookings",
    label: "ROOMS",
    group: "Rooms",
    className: "bookings",
    iconClass: "icon-booking",
    cardName: "Rooms",
  },
  {
    key: "bookingsAdd",
    label: "ADD ROOMS",
    group: "Rooms",
    className: "bookings",
    iconClass: "icon-booking-add",
    cardName: "Add Rooms",
  },
  {
    key: "bookingConfirmation",
    label: "BOOKING CONFIRMATION",
    group: "Rooms",
    className: "booking-confirmation",
    iconClass: "icon-booking-confirmation",
    cardName: "Booking Confirmation",
  },
  {
    key: "blockRooms",
    label: "BLOCK ROOMS",
    group: "Rooms",
    className: "block-rooms",
    iconClass: "icon-booking",
    cardName: "Block Rooms",
  },
  {
    key: "manualBooking",
    label: "MANUAL BOOKING",
    group: "Rooms",
    className: "manual-booking",
    iconClass: "icon-booking",
    cardName: "Manual Booking",
  },
  {
    key: "roomsAvailability",
    label: "ROOMS AVAILABILITY",
    group: "Rooms",
    className: "rooms-availability",
    iconClass: "icon-booking",
    cardName: "Rooms Availability",
  },
  {
    key: "video",
    label: "VIDEOS",
    group: "Upload",
    className: "videos",
    iconClass: "icon-video",
    cardName: "Videos",
  },
  {
    key: "books",
    label: "BOOKS",
    group: "Upload",
    className: "books",
    iconClass: "icon-book",
    cardName: "Books",
  },
  {
    key: "images",
    label: "GALLERY",
    group: "Upload",
    className: "images",
    iconClass: "icon-images",
    cardName: "Images",
  },
];
